<template>
  <div>
    <div
      v-show="
        reportInCreationStatus === REPORT_IN_CREATION_STATUS.NOT_GENERATED ||
        reportInCreationStatus === REPORT_IN_CREATION_STATUS.FAILED
      "
    >
      <slot name="reportButtons">
        <Button class="w-1/2" id="export-button" @click="emit('generateReport')" label="Export" />
      </slot>
    </div>
    <div v-show="isGeneratingReport" class="mt-4" id="generating-report-message">
      <h3>Generating download...</h3>
      <p class="text-sm">
        You can leave this page. We’ll also email you the report when it’s ready.
      </p>
    </div>
    <div
      v-show="reportInCreationStatus === REPORT_IN_CREATION_STATUS.COMPLETE"
      class="mt-4"
      id="report-ready-message"
    >
      <span>Report ready.</span>
      <a
        id="download-link"
        class="text-fg-link-primary"
        :href="reportLink"
        target="_blank"
        @click="emit('afterReportDownloaded')"
      >
        Download
      </a>
    </div>
    <p
      id="failed-report-message"
      class="mt-1 text-fg-error"
      v-show="reportInCreationStatus === REPORT_IN_CREATION_STATUS.FAILED"
    >
      Failed to generate report. Please try again.
    </p>
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button'

import {
  REPORT_IN_CREATION_STATUS,
  ReportInCreationStatus,
} from '@/modules/report/composables/useGenerateReport'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (event: 'afterReportDownloaded'): void
  // eslint-disable-next-line no-unused-vars
  (event: 'generateReport'): void
}>()

defineProps<{
  reportInCreationStatus: ReportInCreationStatus
  isGeneratingReport: boolean
  reportLink: string
}>()
</script>
